import { EntityStatusBadgeVariant } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum JobStateName {
    PENDING = 'pending',
    PROCESSING = 'processing',
    PROCESSED = 'processed',
    FAILED = 'failed',
    NO_DATA = 'no_data'
}

export class JobState {
    static readonly PENDING = new JobState(
        JobStateName.PENDING,
        (
            <FormattedMessage
                id='Objects.JOB.IN_QUEUE'
                description='label for in queue'
                defaultMessage='In queue'
            />
        )
    );

    static readonly PROCESSING = new JobState(
        JobStateName.PROCESSING,
        (
            <FormattedMessage
                id='Objects.JOB.IN_PROGRESS'
                description='label for in progress'
                defaultMessage='In progress'
            />
        )
    );

    static readonly PROCESSED = new JobState(
        JobStateName.PROCESSED,
        (
            <FormattedMessage
                id='Objects.JOB.COMPLETED'
                description='label for completed'
                defaultMessage='Completed'
            />
        )
    );

    static readonly FAILED = new JobState(
        JobStateName.FAILED,
        (
            <FormattedMessage
                id='Objects.JOB.FAILED'
                description='label for failed'
                defaultMessage='Failed'
            />
        )
    );

    static readonly NO_DATA = new JobState(
        JobStateName.NO_DATA,
        (
            <FormattedMessage
                id='Objects.JOB.NO_DATA'
                description='label for no data'
                defaultMessage='No data'
            />
        )
    );

    static readonly ALL = [JobState.PENDING, JobState.PROCESSING, JobState.PROCESSED, JobState.FAILED, JobState.NO_DATA];

    private constructor(
        public readonly value: JobStateName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: JobStateName): JobState | undefined {
        return this.ALL.find((a) => a.value == action);
    }

    static getType(state: JobStateName): string {
        switch (state) {
            case JobStateName.PROCESSED:
                return 'bg-status-success';
            case JobStateName.FAILED:
                return 'bg-status-danger';
            case JobStateName.PROCESSING:
            case JobStateName.NO_DATA:
                return 'bg-status-warning';
            case JobStateName.PENDING:
                return 'bg-brand-muted';
        }
    }

    static getBadgeVariant(state: JobStateName): EntityStatusBadgeVariant {
        switch (state) {
            case JobStateName.PENDING:
                return EntityStatusBadgeVariant.Draft;
            case JobStateName.PROCESSING:
                return EntityStatusBadgeVariant.AwaitingPickUp;
            case JobStateName.PROCESSED:
                return EntityStatusBadgeVariant.Completed;
            case JobStateName.FAILED:
                return EntityStatusBadgeVariant.Failed;
            case JobStateName.NO_DATA:
            default:
                return EntityStatusBadgeVariant.Cancelled;
        }
    }
}
